export function isAPIError(error) {
    return 'json' in error;
}
export function getAPIErrorMessage(apiError, defaultMsg) {
    return (apiError.json?.error_ui ??
        apiError.json?.error ??
        apiError.error.message ??
        apiError.error_ui ??
        defaultMsg);
}
